import styled from 'styled-components';

export const Container = styled.div`
  padding-left: 250px;

  height: 100%;
  width: 100%;
`;

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;

  padding: 1rem;
`;

export const Title = styled.h1`

`;